import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Document } from 'src/app/modules/core/store/models/document.model';

export class TropicalCycloneService {
  constructor() {}

  public static getCycloneImageForCategory(cycloneCatCode: string): string {
    switch (cycloneCatCode) {
      default:
        // case 'TD':
        return 'tropical-cyclone_tropical-depression';
      case 'TS':
        return 'tropical-cyclone_tropical-storm';
      case 'H1':
        return 'tropical-cyclone_hurricane';
      case 'H2':
        return 'tropical-cyclone_hurricane';
      case 'H3':
        return 'tropical-cyclone_major-hurricane';
      case 'H4':
        return 'tropical-cyclone_major-hurricane';
      case 'H5':
        return 'tropical-cyclone_major-hurricane';
      case 'TY':
        return 'tropical-cyclone_hurricane';
      case 'STY':
        return 'tropical-cyclone_super-typhoon';
    }
  }

  public static getCycloneColorForCategory(cycloneCatCode: string): string {
    switch (cycloneCatCode) {
      case 'TD':
        return '#518C29';
      case 'TS':
        return '#A1C33C';
      case 'H1':
        return '#F5BD42';
      case 'H2':
        return '#F5BD42';
      case 'H3':
        return '#EC9C37';
      case 'H4':
        return '#E27A2E';
      case 'H5':
        return '#D5562A';
      case 'TY':
        return '#C42C29';
      case 'STY':
        return '#C42C29';
      default:
        return '#D6D5DD';
    }
  }

  public static getCategoryCodesBySeverity(): string[] {
    return ['TD', 'TS', 'TY', 'H1', 'H2', 'H3', 'H4', 'H5', 'STY'];
  }

  public static getInactiveColor(): string {
    return '#D6D5DD';
  }

  public static getCycloneCategory(dataset: Dataset, document: Document): string {
    const catValue = document.position_storm_cat;
    const cycloneCatField = dataset.schema.fields.find(f => f.systemName == 'position_storm_cat');
    const ret = cycloneCatField?.picklistValues?.find(v => v.uId == catValue)?.value;

    return ret || catValue;
  }

  public static getFullIconUrl(basePath: string): string {
    return `${basePath}/v1/meta/markers/tropical-cyclone/CCEAFF/0/0/normal/tropical-cyclone.png`;
  }

  public static getFillCategoryImageUrl(basePath: string, category: string): string {
    const backColor = TropicalCycloneService.getCycloneColorForCategory(category);
    const imageName = TropicalCycloneService.getCycloneImageForCategory(category);

    return `${basePath}/v1/meta/markers/${imageName}/${backColor.replace('#', '')}/0/0/default/${imageName}.png`;
  }
}
